import { IUseGenerateQrCodes } from './types';
import QRCode from 'react-qr-code';

export const JxtQrCodes = ({ value, size = 100, bgColor = 'white', fgColor = 'black' }: IUseGenerateQrCodes) => {
  return <QRCode value={value} size={size} bgColor={bgColor} fgColor={fgColor} level="M" />;
};

export default JxtQrCodes;
